import React from 'react';
import { Sparkles, Globe, Briefcase } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const FeaturesGrid = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <section id="services" style={{ padding: '120px 7.6923%', background: '#FAFAFA' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <p style={{ color: 'rgba(13, 44, 34, 0.6)', fontSize: '12px', fontWeight: '600', letterSpacing: '2px', marginBottom: '16px', textTransform: 'uppercase' }}>
          {t('services.tagline')}
        </p>
        <h2 className="font-display" style={{ fontSize: '48px', fontWeight: '700', color: '#0D2C22', marginBottom: '16px' }}>
          {t('services.title')}
        </h2>
        <p style={{ fontSize: '20px', color: 'rgba(13, 44, 34, 0.7)', marginBottom: '80px', maxWidth: '700px' }}>
          {t('services.description')}
        </p>

        <div style={{ display: 'grid', gap: '80px' }}>
          {/* Primary Feature: SaaS Solutions */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '60px', alignItems: 'center' }}>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                <div style={{ 
                  width: '40px', 
                  height: '40px', 
                  background: '#F7F5F0', 
                  borderRadius: '8px', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center' 
                }}>
                  <Sparkles size={24} color="#0D2C22" />
                </div>
                <h3 className="font-display" style={{ fontSize: '32px', fontWeight: '700', color: '#0D2C22' }}>
                  {t('services.saas')}
                </h3>
              </div>
              <p style={{ fontSize: '18px', color: 'rgba(13, 44, 34, 0.7)', lineHeight: '1.6', marginBottom: '24px' }}>
                {t('services.saasDesc')}
              </p>
              <button
                onClick={() => {
                  navigate('/sales-leads-pro');
                  setTimeout(() => window.scrollTo(0, 0), 100);
                }}
                style={{
                  background: '#0D2C22',
                  color: '#FFFFFF',
                  border: 'none',
                  padding: '14px 32px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  borderRadius: '8px',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  boxShadow: '0 2px 8px rgba(13, 44, 34, 0.15)',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'rgba(13, 44, 34, 0.9)';
                  e.target.style.transform = 'translateY(-1px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = '#0D2C22';
                  e.target.style.transform = 'translateY(0)';
                }}
              >
                Learn More
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </button>
            </div>
            <div>
              <img
                src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxkYXNoYm9hcmQlMjBhbmFseXRpY3N8ZW58MHx8fHwxNzg1MjQ4NDU2fDA&ixlib=rb-4.1.0&q=85"
                alt="SaaS Dashboard"
                style={{ width: '100%', height: 'auto', borderRadius: '16px', border: '1px solid rgba(13, 44, 34, 0.1)', boxShadow: '0 8px 32px rgba(13, 44, 34, 0.08)' }}
              />
            </div>
          </div>

          {/* Secondary Features Grid */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '24px' }}>
            {/* AI Website Building Card */}
            <div
              style={{
                background: '#FFFFFF',
                border: '1px solid rgba(13, 44, 34, 0.1)',
                padding: '40px',
                borderRadius: '16px',
                transition: 'all 0.3s'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 8px 32px rgba(13, 44, 34, 0.12)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              <div style={{ 
                width: '40px', 
                height: '40px', 
                background: '#F7F5F0', 
                borderRadius: '8px', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                marginBottom: '20px' 
              }}>
                <Globe size={24} color="#0D2C22" />
              </div>
              <h4 className="font-display" style={{ fontSize: '24px', fontWeight: '700', color: '#0D2C22', marginBottom: '12px' }}>
                {t('services.aiWebsite')}
              </h4>
              <p style={{ fontSize: '16px', color: 'rgba(13, 44, 34, 0.7)', lineHeight: '1.6', marginBottom: '20px' }}>
                {t('services.aiWebsiteDesc')}
              </p>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                <li style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', marginBottom: '12px', fontSize: '14px', color: 'rgba(13, 44, 34, 0.6)' }}>
                  <div style={{ width: '4px', height: '4px', background: '#E5A93D', borderRadius: '50%', marginTop: '6px', flexShrink: 0 }}></div>
                  <div>
                    <span>{t('services.feature1')}</span>
                    <div style={{ fontSize: '12px', fontStyle: 'italic', marginTop: '2px', color: 'rgba(13, 44, 34, 0.5)' }}>
                      + €20 per month for keeping the landing page running
                    </div>
                  </div>
                </li>
                <li style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', marginBottom: '12px', fontSize: '14px', color: 'rgba(13, 44, 34, 0.6)' }}>
                  <div style={{ width: '4px', height: '4px', background: '#E5A93D', borderRadius: '50%', marginTop: '6px', flexShrink: 0 }}></div>
                  <div>
                    <span>{t('services.feature2')}</span>
                    <div style={{ fontSize: '12px', fontStyle: 'italic', marginTop: '2px', color: 'rgba(13, 44, 34, 0.5)' }}>
                      + €20 per month for keeping the fullstack app running
                    </div>
                  </div>
                </li>
                <li style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px', fontSize: '14px', color: 'rgba(13, 44, 34, 0.6)' }}>
                  <div style={{ width: '4px', height: '4px', background: '#E5A93D', borderRadius: '50%' }}></div>
                  {t('services.feature3')}
                </li>
              </ul>
            </div>

            {/* AI Website Building Image Card */}
            <div
              style={{
                background: '#FFFFFF',
                border: '1px solid rgba(13, 44, 34, 0.1)',
                borderRadius: '16px',
                overflow: 'hidden',
                transition: 'all 0.3s'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 8px 32px rgba(13, 44, 34, 0.12)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              <img
                src="https://images.unsplash.com/photo-1498050108023-c5249f4df085?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBBSSUyMHdlYnNpdGUlMjBkZXZlbG9wbWVudCUyMGNvZGluZ3xlbnwwfHx8fDE3OTE2MjI4ODV8MA&ixlib=rb-4.1.0&q=85"
                alt="Professional AI Website Development"
                style={{ 
                  width: '100%', 
                  height: '280px',
                  objectFit: 'cover',
                  objectPosition: 'center'
                }}
              />
              <div style={{ padding: '24px' }}>
                <h4 className="font-display" style={{ fontSize: '20px', fontWeight: '700', color: '#0D2C22', marginBottom: '8px' }}>
                  {t('services.imageTitle')}
                </h4>
                <p style={{ fontSize: '14px', color: 'rgba(13, 44, 34, 0.7)', lineHeight: '1.6' }}>
                  {t('services.imageDesc')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesGrid;
